import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-dla',
  templateUrl: './dla.component.html',
  styleUrls: ['./dla.component.scss'],
})


export class DlaComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['dla-video'];
  }

}
